import axios from "axios";
import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { useSelector } from "react-redux";

const options = {
	legend: {
		show: false,
		position: "bottom",
	},
	colors: ["#00B05F", "#3C50E0", "#E2E8F0"],
	labels: ["Complete", "In Progress", "Available"],
	chart: {
		fontFamily: "Satoshi, sans-serif",
		type: "donut",
	},
	plotOptions: {
		pie: {
			donut: {
				size: "70%",
				labels: {
					show: true,
					total: {
						show: true,
						label: "Total Juzs",
						fontSize: "14px",
					},
				},
			},
		},
	},
	dataLabels: {
		enabled: false,
	},
	responsive: [
		{
			breakpoint: 1024,
			options: {
				chart: {
					height: 300,
				},
			},
		},
	],
};

const Legend = ({ color, label, value }) => (
	<div className="flex items-center gap-2">
		<span className={`h-3 w-3 rounded-full ${color}`} />
		<span className="text-sm text-slate-500">{label}</span>
		<span className="text-sm font-semibold text-slate-700">{value}</span>
	</div>
);

const ChartOne = () => {
	const user = useSelector((st) => st.user).user;
	const [stats, setStats] = useState({
		totalCount: 0,
		completeCount: 0,
		reservedCount: 0,
		availableCount: 0,
	});

	useEffect(() => {
		fetchKhatamStats();
	}, []);

	const fetchKhatamStats = async () => {
		try {
			const response = await axios.get(
				`${process.env.REACT_APP_API_URL}/api/v1/khatam-al-quran/user-stats`,
				{
					headers: {
						Authorization: `Bearer ${user?.token}`,
					},
				}
			);
			const data = response.data.data;
			setStats({
				totalCount: data.totalCount || 0,
				completeCount: data.completeCount || 0,
				reservedCount: data.reservedCount || 0,
				availableCount: data.availableCount || 0,
			});
		} catch (error) {
			console.error("Failed to fetch Khatam al Quran stats:", error);
		}
	};

	const progress =
		stats.totalCount > 0
			? Math.round((stats.completeCount / stats.totalCount) * 100)
			: 0;

	const series = [
		stats.completeCount,
		stats.reservedCount,
		stats.availableCount,
	];

	return (
		<div className="col-span-12 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm xl:col-span-8">
			<div className="flex flex-wrap items-start justify-between gap-3 sm:flex-nowrap">
				<div>
					<h4 className="text-lg font-semibold text-slate-800">
						Khatam al Quran Progress
					</h4>
					<p className="mt-1 text-sm text-slate-500">
						{stats.completeCount} of {stats.totalCount} juzs completed
					</p>
				</div>
				<span className="inline-flex items-center rounded-full bg-emerald-50 px-3 py-1 text-sm font-semibold text-emerald-600">
					{progress}% complete
				</span>
			</div>

			<div className="mt-2 flex flex-wrap items-center gap-x-6 gap-y-2">
				<Legend color="bg-emerald-500" label="Complete" value={stats.completeCount} />
				<Legend color="bg-indigo-500" label="In Progress" value={stats.reservedCount} />
				<Legend color="bg-slate-300" label="Available" value={stats.availableCount} />
			</div>

			<div>
				<div id="chartOne" className="mx-auto flex justify-center">
					<ReactApexChart
						options={options}
						series={series}
						type="donut"
						height={340}
					/>
				</div>
			</div>
		</div>
	);
};

export default ChartOne;
